<template>
  <el-card v-loading="loading">
    <el-row :gutter="20">
      <el-col :span="10" :xs="24">
        <h3>Telegram Notifications</h3>
        <span
          >Connect your Telegram account to receive notifications about
          important events.</span
        >
        <div class="flex flex--align-center flex--center">
          <font-awesome-icon
            :icon="['fab', 'telegram']"
            size="6x"
            class="telegram-icon"
          />
        </div>
      </el-col>

      <el-col :span="14" :xs="24">
        <template v-if="connected">
          <h4>
            Status:
            <el-tag type="success" size="small">Connected</el-tag>
          </h4>
          <p>
            Connected as: <b>@{{ telegramUsername }}</b>
          </p>
          <el-button
            type="danger"
            plain
            :disabled="loading"
            @click="onDisconnect"
          >
            Disconnect Telegram
          </el-button>
        </template>

        <template v-else>
          <h4>
            Status:
            <el-tag type="info" size="small">Not connected</el-tag>
          </h4>
          <p>
            Click the button below to connect your Telegram account via our bot.
          </p>
          <el-button
            type="primary"
            plain
            :disabled="loading"
            @click="onConnect"
          >
            <font-awesome-icon :icon="['fab', 'telegram']" class="mr-1" />
            Connect Telegram
          </el-button>
        </template>
      </el-col>
    </el-row>
  </el-card>
</template>

<script lang="ts">
import { ref, computed, defineComponent } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'TelegramForm',
  setup() {
    const userStore = useUserStore()
    const loading = ref(false)

    const connected = computed(() => {
      return userStore.connectedMessengers.includes('telegram')
    })

    const telegramUsername = computed(() => {
      return userStore.telegram
    })

    const onConnect = async () => {
      loading.value = true
      try {
        const link = await userStore.GetTelegramLink()
        window.open(link, '_blank')
      } finally {
        loading.value = false
      }
    }

    const onDisconnect = async () => {
      loading.value = true
      try {
        await userStore.DisconnectTelegram()
        ElMessage.success({ message: 'Telegram disconnected' })
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      connected,
      telegramUsername,
      onConnect,
      onDisconnect
    }
  }
})
</script>

<style lang="scss" scoped>
.telegram-icon {
  color: #2ca5e0;
  margin-top: 20px;
}
.mr-1 {
  margin-right: 4px;
}
</style>
